/* ═══════════════════════════════════════════════════════
   ONIALLY — Auto FAQ Accordion + Schema Generator
   Fichier : assets/blog-auto-faq.js
   
   Détecte les blocs .article-faq-data dans les articles,
   les transforme en accordéon cliquable et injecte
   automatiquement le Schema FAQPage pour Google.
   ═══════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  var faqSource = document.querySelector('.article-faq-data');
  if (!faqSource) return;

  /* ── 1. Extraire les paires Q/R ── */
  var headings = faqSource.querySelectorAll('h3');
  if (headings.length === 0) return;

  var faqItems = [];
  for (var i = 0; i < headings.length; i++) {
    var question = headings[i].textContent.trim();
    var answer = '';
    var next = headings[i].nextElementSibling;
    while (next && next.tagName !== 'H3' && next.tagName !== 'H2') {
      answer += next.outerHTML;
      next = next.nextElementSibling;
    }
    if (question && answer) {
      faqItems.push({ q: question, a: answer });
    }
  }

  if (faqItems.length === 0) return;

  /* ── 2. Extraire le titre h2 s'il existe ── */
  var faqTitle = 'Questions fréquentes';
  var titleEl = faqSource.querySelector('h2');
  if (titleEl) {
    faqTitle = titleEl.textContent.trim();
  }

  /* ── 3. Construire le HTML de l'accordéon ── */
  var html = '<div class="auto-faq">';
  html += '<div class="auto-faq__header">';
  html += '<div class="auto-faq__title">' + faqTitle + '</div>';
  html += '</div>';

  for (var j = 0; j < faqItems.length; j++) {
    html += '<div class="auto-faq__item">';
    html += '<button class="auto-faq__question" aria-expanded="false">';
    html += '<span class="auto-faq__q-text">' + faqItems[j].q + '</span>';
    html += '<span class="auto-faq__icon"><svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path class="auto-faq__icon-v" d="M9 3.75V14.25" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M3.75 9H14.25" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></span>';
    html += '</button>';
    html += '<div class="auto-faq__answer" aria-hidden="true">';
    html += '<div class="auto-faq__answer-inner">' + faqItems[j].a + '</div>';
    html += '</div>';
    html += '</div>';
  }

  html += '</div>';

  /* ── 4. Remplacer le bloc source par l'accordéon ── */
  faqSource.outerHTML = html;

  /* ── 5. Activer les clics ── */
  var buttons = document.querySelectorAll('.auto-faq__question');
  for (var k = 0; k < buttons.length; k++) {
    buttons[k].addEventListener('click', function () {
      var item = this.parentElement;
      var answer = item.querySelector('.auto-faq__answer');
      var isOpen = item.classList.contains('is-open');

      if (isOpen) {
        answer.style.maxHeight = null;
        item.classList.remove('is-open');
        this.setAttribute('aria-expanded', 'false');
      } else {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        item.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ── 6. Injecter le Schema FAQPage ── */
  var schemaEntities = [];
  for (var m = 0; m < faqItems.length; m++) {
    /* Nettoyer le HTML des réponses pour le schema */
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = faqItems[m].a;
    var cleanAnswer = tempDiv.textContent || tempDiv.innerText || '';

    schemaEntities.push({
      '@type': 'Question',
      'name': faqItems[m].q,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': cleanAnswer.trim()
      }
    });
  }

  var schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': schemaEntities
  };

  var scriptTag = document.createElement('script');
  scriptTag.type = 'application/ld+json';
  scriptTag.textContent = JSON.stringify(schema);
  document.head.appendChild(scriptTag);

});